import React, { useEffect, useMemo, useState } from "react";
import { getCategories, getStores } from "../../lib/mockSales";
import { StockReport } from "./Components/StockReport";
import { StockFilterBar } from "./Components/StockFilterBar";
import { getItemBalance, getStockClosingEntries } from "../../lib/mockStocks";
import { useQuery } from "@tanstack/react-query";
import { ErrorDialog } from "../../components/ui/notification";

/** @param {{ report:string }} args */
const StocksComponent = ({ report }) => {
  const [stockMonths, setStockMonths] = useState(12);
  // const [stockCompare, setStockCompare] = useState("mom");
  const [stockStore, setStockStore] = useState("all");
  const [stockStoreId, setStockStoreId] = useState(-1);
  const [stockCategory, setStockCategory] = useState("all");
  const [stockCategoryId, setStockCategoryId] = useState("-1");
  //(useState < "all") | "Active" | ("Inactive" > "all");

  const [tick, setTick] = useState(0);

  const [dismissed, setDismissed] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const oneYearAgo = useMemo(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
  }, []);
  const firstOfMonth = useMemo(() => {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() - 2);
    return d.toISOString().split("T")[0];
  }, []);

  const [startDate, setStartDate] = useState(firstOfMonth);
  const [endDate, setEndDate] = useState(today);

  const {
    data: stores = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["stores", tick],
    queryFn: getStores,
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: categories = [],
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQuery({
    queryKey: ["categories", tick],
    queryFn: getCategories,
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: stockItems = [],
    isLoading: isLoadingStock,
    isError: isErrorStock,
  } = useQuery({
    queryKey: ["stockItems", tick],
    queryFn: getItemBalance,
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: stockClosingEntries = [],
    isLoading: isLoadingStockClosingEntries,
    isError: isErrorStockClosingEntries,
  } = useQuery({
    queryKey: ["stockClosingEntries", tick, startDate, endDate],
    queryFn: () => getStockClosingEntries({ startDate, endDate }),
    staleTime: 1000 * 60 * 15,
  });

  const queryErrors = useMemo(() => {
    const errors = [
      {
        key: "stores",
        label: "Stores",
        isError: isError,
        error: "Error Loading Stores",
      },
      {
        key: "categories",
        label: "Stock Categories",
        isError: isErrorCategories,
        error: "Error Loading Stock Categories",
      },
      {
        key: "stockItems",
        label: "Stocks",
        isError: isErrorStock,
        error: "Error Loading Items",
      },
      {
        key: "stockClosingEntries",
        label: "Stock Closing",
        isError: isErrorStockClosingEntries,
        error: "Error Loading Stock Closing Entries",
      },
    ];

    return errors
      .filter((e) => e.isError)
      .map((e) => ({
        key: e.key,
        message: `${e.error}`,
      }));
  }, [isErrorStock, isError, isErrorCategories, isErrorStockClosingEntries]);

  const errorSignature = queryErrors.map((e) => e.key).join(",");
  useEffect(() => {
    // console.log("errors");
    setDismissed(false);
  }, [errorSignature]);

  return (
    <>
      {(isLoading ||
        isLoadingCategories ||
        isLoadingStock ||
        isLoadingStockClosingEntries) && (
        <div className="loading-div">
          <div className="spinner"></div>
        </div>
      )}

      <ErrorDialog
        errors={dismissed ? [] : queryErrors}
        onClose={() => setDismissed(true)}
      />

      <StockFilterBar
        report={report}
        months={stockMonths}
        setMonths={setStockMonths}
        //
        today={today}
        oneYearAgo={oneYearAgo}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        //
        store={stockStore}
        storeId={stockStoreId}
        setStore={setStockStore}
        setStoreId={setStockStoreId}
        // stores={[...STOCK_STORES]}
        stores={[...(stores || [])]}
        category={stockCategory}
        categoryId={stockCategoryId}
        setCategory={setStockCategory}
        setCategoryId={setStockCategoryId}
        categories={[...(categories || [])]}
        // categories={[...STOCK_CATEGORIES]}
        onRefresh={() => setTick((t) => t + 1)}
      />

      <section className="pbi-canvas">
        <StockReport
          report={report}
          months={stockMonths}
          store={stockStore}
          storeId={stockStoreId}
          category={stockCategory}
          categoryId={stockCategoryId}
          stockItems={stockItems}
          categories={categories}
          stores={stores}
          stockClosingEntries={stockClosingEntries}
        />
      </section>
    </>
  );
};

export default StocksComponent;
